import { useEffect, useState } from 'react'
import StyledMenu from '../../generic/StyledMenu'
import ReturnToSenderModal from './ReturnToSenderModal'
import { backendGetRequest } from '../../../helpers/callBackend'

const CreditFailureDropdown = ({ paymentRequest, failureObject, anchorElement, open, onClose, updatePaymentRequests }) => {
  const [returnToSenderVisible, setReturnToSenderVisible] = useState(false)
  const [mode, setMode] = useState('return')
  const [balance, setBalance] = useState({})
  const items = [
    {
      onClick: () => {
        setMode('retry')
        setReturnToSenderVisible(true)
      },
      displayText: 'Update Recipient',
    },
    {
      onClick: () => {
        setMode('return')
        setReturnToSenderVisible(true)
      },
      displayText: 'Return to Sender',
    },
  ]

  const getBalance = async () => {
    try {
      const balanceResp = await backendGetRequest('/api/arpari-dwolla/balance', {
        params: {
          payment_request_id: paymentRequest.id,
        },
      })
      setBalance(balanceResp.data?.data)
    } catch (error) {
      setBalance({})
    }
  }

  useEffect(() => {
    getBalance()
  }, [paymentRequest])

  return (
    <>
      <StyledMenu menuItems={items} anchorEl={anchorElement} open={open} onClose={onClose} />
      {returnToSenderVisible && (
        <ReturnToSenderModal
          visible={returnToSenderVisible}
          handleCancelModal={() => setReturnToSenderVisible(false)}
          paymentRequest={paymentRequest}
          failureObject={failureObject}
          mode={mode}
          dwollaBalance={balance}
          updatePaymentRequests={updatePaymentRequests}
        />
      )}
    </>
  )
}

export default CreditFailureDropdown
